import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png"

const WorkOrderApprovalListViewFull = (props) => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

    const [workOrderDetails, setWorkOrderDetails] = useState(null)

    const [currentWorkorderNumber, setCurrentWorkorderNumber] = useState(0)

    const [showDetailsOfWorkorder, setShowDetailsOfWorkorder] = useState(false)

    const todayDate = format(new Date(), "yyyy-MM-dd");

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    const userAccessGroup = currentUserObject[0].accessgrp;

    const initialFilterObject = {
        fromDate: "1900-01-01",
        toDate: todayDate,
        task_creator_id:
            userAccessGroup?.trim().toUpperCase() == "COORDINATOR"
                ? empIDFromUserObjectInLocalStorage
                : "-",
        task_owner_id:
            userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
                userAccessGroup?.trim().toUpperCase() != "ADMIN"
                ? empIDFromUserObjectInLocalStorage
                : "-",
        free_text: "-",
    };

    const [showLeadFilter, setShowLeadFilter] = useState(false);
    const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [quotationList, setQuotationList] = useState(null);
    const [quotationDetailsData, setQuotationDetailsData] = useState(null);
    const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const callAPI = ()=>{
        console.log("currentPageNumber ", currentPageNumber);

            const currentUserDepartment = localStorage.getItem(
                "currentSelectedDepartment"
            );
            const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
            const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

            if (!currentUserObject) {
                console.error("No user data found in localStorage");
                return;
            }

            const userAccessGroup = currentUserObject[0].accessgrp;

            console.log("currentUserDepartment:", currentUserDepartment);
            console.log("userAccessGroup:", userAccessGroup);

            fetchQuotationList(
                userAccessGroup,
                currentUserDepartment,
                initialFilterObject,
                empIDFromUserObjectInLocalStorage
            );
    }

    useEffect(() => {
        if (currentPageNumber) {
            callAPI()
        }
    }, [currentPageNumber]);

    const fetchQuotationList = (
        userAccessGroup,
        currentUserDepartment,
        filterObjectFromModal,
        empIDFromUserObjectInLocalStorage
    ) => {

        console.log("filterObjectFrom Modal", filterObjectFromModal)

        setLoading(true);

        try {
            let url = "";

            if (userAccessGroup === "ADMIN") {
                url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/WorkorderApproval/-/${currentUserDepartment}`
            }

            axios.get(url).then((res) => {
                console.log("Quotation List:", res.data);
                setQuotationList(res.data);
            });
        } catch (error) {
            console.error("Error fetching quotations:", error);
        } finally {
            setLoading(false);
        }
    };


    const applyFilters = () => { };

    useEffect(() => {
        const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
        const userAccessGroup = currentUserObject[0].accessgrp;
        setCurrentUserGroupAccess(userAccessGroup);
    }, []);

    const callAPIToChangeStatus = (quot_slNo, statusByAdmin) => {

        const currentUserDepartment = localStorage.getItem(
            "currentSelectedDepartment"
        );

        const currentUserfromLocalStorage = JSON.parse(
            localStorage.getItem("currentUser")
        );

        let currentUserEMPID = "-";

        if (currentUserfromLocalStorage) {
            console.log(
                "currentUserfromLocalStorage[0] ",
                currentUserfromLocalStorage[0]
            );
            currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
        } else {
            console.log(
                "currentUserfromLocalStorage[0] else",
                currentUserfromLocalStorage[0]
            );
        }


        const jsonObject = [{
            CmpCode: company_code_from_local_storage,
            mode: "WORKORDER",
            DocNo: quot_slNo + "",
            deptno: currentUserDepartment,
            Status: statusByAdmin,
            Comments: "",
            UserID: currentUserEMPID?.trim(),
            created_on: format(new Date(), "yyyy-MM-dd"),

        }]

        const jsonToSend = JSON.stringify(jsonObject);

        const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;

        axios.post(apiUrl, jsonToSend, {
            headers: {
                "Content-Type": "application/json",
            },
        }).then((res) => {

            if (res.data.result == "Saved") {

                alert("Saved")

                callAPI()

            } else {
                alert("Something went wrong")
            }


        }).catch((err) => {

        })
    }


    const clickedOnDetails = (order_number) => {

        setShowDetailsOfWorkorder(prev => !prev)
        setCurrentWorkorderNumber(order_number)

    }

    const closePopupClicked = ()=>{
        setShowDetailsOfWorkorder(false)
        setCurrentWorkorderNumber(0)
    }

    const callAPIToGetDetailsOfWorkorder = () => {

        const currentUserDepartment = localStorage.getItem(
            "currentSelectedDepartment"
        );

        let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/WorkorderDetails/${currentWorkorderNumber}/${currentUserDepartment}`
        axios.get(apiUrl).then((res) => {
            console.log("res data ", res.data)
            setWorkOrderDetails(res.data)
        }).catch((err) => {

        })
    }

    useEffect(() => {

        console.log("showDetailsOfWorkorder currentworkorder ", showDetailsOfWorkorder, currentWorkorderNumber)
        if (showDetailsOfWorkorder && currentWorkorderNumber) {
            callAPIToGetDetailsOfWorkorder()
        }


    }, [showDetailsOfWorkorder, currentWorkorderNumber])

    return (
        <div className="min-h-screen px-6">
            <div className="flex justify-between items-center mb-4 ">
                <h3 className="text-xl font-normal text-gray-800 ">Work Order List</h3>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>

                {currentPageNumber != 1 && (
                    <button
                        className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                        onClick={() =>
                            setCurrentPageNumber((prev) => (prev - 1 >= 1 ? prev - 1 : 1))
                        }
                    >
                        Previous
                    </button>
                )}
                <button
                    onClick={() => setCurrentPageNumber((prev) => prev + 1)}
                    className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                    style={{ marginLeft: "10px" }}
                >
                    Next
                </button>{" "}
            </div>

            <div className="bg-white rounded-lg shadow-sm">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-200 text-gray-600 text-sm">
                            <th className="p-1">Work Order Number</th>
                            <th className="p-1">Date</th>
                            <th className="p-1">SO No.</th>
                            <th className="p-1">Customer Name</th>
                            <th className="p-1">Customer Account</th>
                            <th className="p-1 text-center w-[240px]">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quotationList?.map((list, index) => (
                            <tr key={index} className="border-b text-sm hover:bg-gray-50">
                                <td className="p-1">{list.WO_NO}</td>
                                {/* <td className="p-1 ">{list.so_date}</td> */}
                                <td className="p-1">
                                    {dayjs(list.wo_date).format("DD/MM/YYYY")}
                                </td>
                                <td className="p-1">{list.SO_NO}</td>
                                <td className="p-1">{list.customer?.trim()}</td>
                                <td className="p-1">{list.ACCOUNT}</td>
                                <td className="p-1 ">
                                    <div className="flex justify-between items-center gap-1">

                                        {
                                            <div>
                                                <button
                                                    className="bg-blue-500 hover:bg-gray-400 text-white px-2 py-1 rounded text-xs"
                                                    // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                                                    onClick={() => callAPIToChangeStatus(list.WO_NO, "Approved")}
                                                >
                                                    Approve
                                                </button>

                                                <button
                                                    className="ms-2 bg-red-500 hover:bg-gray-400 text-white px-2 py-1 rounded text-xs"
                                                    // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                                                    onClick={() => callAPIToChangeStatus(list.WO_NO, "Rejected")}
                                                >
                                                    Reject
                                                </button>

                                                <button
                                                    className="ms-2 bg-black hover:bg-gray-400 text-white px-2 py-1 rounded text-xs"
                                                    // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                                                    onClick={() => clickedOnDetails(list.WO_NO)}
                                                >
                                                    Details
                                                </button>
                                            </div>


                                        }




                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {loading ? (
                <p className="inset-0 fixed flex justify-center items-center">
                    Loading quotations... <CircularProgress size={24} />
                </p> // Show loader while fetching
            ) : (
                <ul>

                </ul>
            )}


            {
                showDetailsOfWorkorder &&
                <div
                    className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
                    style={{ zIndex: 70 }}
                >
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">

                        <div className="flex justify-between">
                            <h4>Work Order Details</h4>
                            <button className="bg-black text-white px-4 py-1" onClick={()=>closePopupClicked()}>Close</button>
                        </div>

                        <div className="mt-4">
                            <p>Code</p>
                            <p style={{ color: "#787676" }}>{workOrderDetails[0]?.Code}</p>
                        </div>

                        <div className="mt-2">
                            <p>Description</p>
                            <p style={{ color: "#787676" }}>{workOrderDetails[0]?.Description}</p>
                        </div>

                        <div className="mt-2">
                            <p>Quantity</p>
                            <p style={{ color: "#787676" }}>{workOrderDetails[0]?.Qty}</p>
                        </div>

                    </div>
                </div>
            }

        </div>
    );
};

export default WorkOrderApprovalListViewFull;
